import type {
    GoogleIntegrationsResponse,
    GoogleWorkspaceIntegration,
} from "../../../store/features/integrations/integrationsService";

export const getActiveGoogleIntegration = (
    response: GoogleIntegrationsResponse | undefined,
): GoogleWorkspaceIntegration | undefined => {
    const integration = response?.current;
    if (integration?.details.verified !== true || integration.details.disabled) return undefined;

    return integration;
};
